import { AGING_COLORS_BY_ID, LEGACY_AGING_LABELS } from './dealershipSettings';

// Today's colour per aging bucket: give the bucket id (1–4, from
// utils/dealershipSettings unitAgingBucketId); a legacy label still works.
export const getAgingStatusColor = (bucket) => (
    AGING_COLORS_BY_ID[typeof bucket === 'number' ? bucket : LEGACY_AGING_LABELS[bucket]] || '#718096'
);

export const getSellSpeedBucketStyle = (bucket) => {
    if (!bucket) return { bg: '#f1f5f9', text: '#94a3b8', border: '#cbd5e1', label: 'N/A' };
    const normalized = bucket.toLowerCase();
    if (normalized.includes('quick')) return { bg: '#dcfce7', text: '#15803d', border: '#86efac', label: 'Quick Sell' };
    if (normalized.includes('normal')) return { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd', label: 'Normal' };
    if (normalized.includes('slow')) return { bg: '#fef3c7', text: '#b45309', border: '#fcd34d', label: 'Slow' };
    if (normalized.includes('critical')) return { bg: '#fee2e2', text: '#b91c1c', border: '#fca5a5', label: 'Critical' };
    return { bg: '#f1f5f9', text: '#94a3b8', border: '#cbd5e1', label: bucket };
};

// Sell-speed risk traffic light (calibrated Ladenhüter / slow-mover risk).
// Tier comes from the backend RiskTier field ("Red" | "Yellow" | "Green").
export const getRiskTierStyle = (tier) => {
    switch (tier) {
        case 'Red':
            return { bg: '#fee2e2', text: '#b91c1c', border: '#fca5a5', label: 'High', dot: '#b91c1c' };
        case 'Yellow':
            return { bg: '#fef3c7', text: '#b45309', border: '#fcd34d', label: 'Medium', dot: '#b45309' };
        case 'Green':
            return { bg: '#dcfce7', text: '#15803d', border: '#86efac', label: 'Low', dot: '#15803d' };
        default:
            return { bg: '#f1f5f9', text: '#94a3b8', border: '#cbd5e1', label: 'Unscored', dot: '#94a3b8' };
    }
};

export const getBuyerHeatStatus = (quoteCount, daysSince) => {
    if (!quoteCount || daysSince == null) return { label: 'No Interest', color: '#94a3b8', bg: '#f1f5f9' };
    if (daysSince <= 7) return { label: 'Hot', color: '#b91c1c', bg: '#fee2e2' };
    if (daysSince <= 30) return { label: 'Warm', color: '#b45309', bg: '#fef3c7' };
    if (daysSince <= 90) return { label: 'Cold', color: '#1d4ed8', bg: '#dbeafe' };
    return { label: 'No Interest', color: '#94a3b8', bg: '#f1f5f9' };
};

export const getAnomalyStyle = (severity) => {
    if (severity === 'critical') return { bg: '#fee2e2', text: '#b91c1c', border: '#fca5a5' };
    if (severity === 'warning') return { bg: '#fef3c7', text: '#b45309', border: '#fcd34d' };
    if (severity === 'positive') return { bg: '#dcfce7', text: '#15803d', border: '#86efac' };
    return null;
};

export const getListingAgeColor = (days) => {
    if (!days) return '#718096';
    if (days <= 90) return '#15803d';
    if (days <= 180) return '#1d4ed8';
    if (days <= 365) return '#b45309';
    return '#b91c1c';
};

export const getCompletenessColor = (pct) => {
    if (pct >= 70) return '#15803d';
    if (pct >= 40) return '#b45309';
    return '#b91c1c';
};
